import React from "react";

interface BloodPressureTooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: {
      systolic: number;
      diastolic: number;
    };
  }>;
  colors: { primary: { main: string } };
}

/**
 * Custom tooltip component for blood pressure charts
 */
const BloodPressureTooltip: React.FC<BloodPressureTooltipProps> = ({
  active,
  payload,
  colors,
}) => {
  if (active && payload && payload.length > 0) {
    const data = payload[0].payload;
    return (
      <div
        style={{
          padding: "8px 12px",
          backgroundColor: "#fff",
          border: "1px solid #E8E8E9",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <p
          style={{
            margin: "0",
            fontSize: "12px",
            color: colors.primary.main,
          }}
        >
          ● Systolic: {Math.round(data.systolic)} mmHg
        </p>
        <p
          style={{
            margin: "0",
            fontSize: "12px",
            color: "#000",
          }}
        >
          ◇ Diastolic: {Math.round(data.diastolic)} mmHg
        </p>
      </div>
    );
  }
  return null;
};

export default BloodPressureTooltip;
